<template>
  <div id="usuarios">
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Usuarios</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small :loading="loading" color="green" class="white--text" @click="syncUsers">Sincronizar</v-btn>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="usuarios" :loading="loading" :search="search"
      rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetailUser(props.item.id)">{{ props.item.id }}</td>
          <td class="text-xs-center" @click="showDetailUser(props.item.id)">{{ props.item.estado }}</td>
          <td class="text-xs-center" @click="showDetailUser(props.item.id)">{{ props.item.alias }}</td>
          <td class="text-xs-center" @click="showDetailUser(props.item.id)">{{ props.item.nombre }}</td>
          <td class="text-xs-center" @click="showDetailUser(props.item.id)">{{ props.item.fecha_registro }}</td>
          <td class="text-xs-center" @click="showDetailUser(props.item.id)">{{ props.item.fecha_actualizacion }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogDetUser" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle completo de usuario</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <v-text-field v-model="detalle.username" label="Username" box readonly></v-text-field>
                  <v-text-field v-model="detalle.rfc" label="RFC" box readonly></v-text-field>
                  <v-text-field v-model="detalle.puesto" label="Puesto" box readonly></v-text-field>
                  <v-text-field v-model="detalle.direccion" label="Dirección" box readonly></v-text-field>
                  <v-text-field v-model="detalle.ubicacion" label="Ubicación" box readonly></v-text-field>
                  <v-text-field v-model="detalle.fecha_registro" label="Fecha de registro" box readonly></v-text-field>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <v-text-field v-model="detalle.nombre" label="Nombre" box readonly></v-text-field>
                  <v-text-field v-model="detalle.no_empleado" label="No. Empleado" box readonly></v-text-field>
                  <v-text-field v-model="detalle.departamento" label="Departamento" box readonly></v-text-field>
                  <v-text-field v-model="detalle.empresa" label="Empresa" box readonly></v-text-field>
                  <v-text-field v-model="detalle.jefe_inmediato" label="Jefe inmediato" box readonly></v-text-field>
                  <v-text-field v-model="detalle.fecha_actualizacion" label="Fecha de actualización" box readonly></v-text-field>
                </v-container>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <p>
                        <h3 class="grey--text">ESTADO</h3>
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <p>
                        <v-btn block small round dark color="blue-grey" @click="questionEst = true">
                          Actualizar
                        </v-btn>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-radio-group v-model="detalle.estado" :mandatory="false" row>
                    <v-radio label="Activo" color="success" value="activo"></v-radio>
                    <v-radio label="Inactivo" color="error" value="inactivo"></v-radio>
                  </v-radio-group>
                  <br/>
                  <v-divider></v-divider>
                  <br/>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <p>
                        <h3 class="grey--text">PERMISOS</h3>
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <p>
                        <v-btn block small round dark color="blue-grey" @click="questionPer = true">
                          Actualizar
                        </v-btn>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-switch v-model="detalle.permisos" label="Administrador" color="primary" value="administrador"></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-switch v-model="detalle.permisos" label="Contabilidad " color="primary" value="contabilidad"></v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-switch v-model="detalle.permisos" label="Caja chica" color="primary" value="caja_chica"></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-switch v-model="detalle.permisos" label="Gastos de viaje " color="primary" value="gastos_viaje"></v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-switch v-model="detalle.permisos" label="Tesorería" color="primary" value="tesoreria"></v-switch>
                    </v-flex>
                     <v-flex xs12 sm12 md6>
                      <v-switch v-model="detalle.permisos" label="Solicitud AMEX" color="primary" value="solicitud_amex"></v-switch>
                    </v-flex>
                  </v-layout>
                   <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-switch v-model="detalle.permisos" label="Comprobación AMEX" color="primary" value="comprobacion_amex"></v-switch>
                    </v-flex>
                     <v-flex xs12 sm12 md6>
                      <v-switch v-model="detalle.permisos" label="Gastos de representación" color="primary" value="gastos_representacion"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <p>
                        <h3 class="grey--text">CUENTA DE NÓMINA</h3>
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <p>
                        <v-btn block small round dark color="blue-grey" @click="questionCtaNom = true">
                          Actualizar
                        </v-btn>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-text-field v-model="detalle.nomina_banco" label="Banco" readonly></v-text-field>
                      <v-text-field v-model="detalle.nomina_tarjeta" label="No. Tarjeta" :readonly="!(roles.includes('administrador') || roles.includes('contabilidad') || roles.includes('tesoreria'))"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field v-model="detalle.nomina_cuenta" label="No. Cuenta" :readonly="!(roles.includes('administrador') || roles.includes('contabilidad') || roles.includes('tesoreria'))"></v-text-field>
                      <v-text-field v-model="detalle.nomina_clabe" label="Referencia interbancaria" :readonly="!(roles.includes('administrador') || roles.includes('contabilidad') || roles.includes('tesoreria'))"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <br/>
                  <v-divider></v-divider>
                  <br/>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <p>
                        <h3 class="grey--text">CUENTA PERSONAL</h3>
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <p>
                        <v-btn block small round dark color="blue-grey" @click="questionCtaPer = true">
                          Actualizar
                        </v-btn>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-text-field v-model="detalle.personal_banco" label="Banco" readonly></v-text-field>
                      <v-text-field v-model="detalle.personal_tarjeta" label="No. Tarjeta" :readonly="!(roles.includes('administrador') || roles.includes('contabilidad') || roles.includes('tesoreria'))"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field v-model="detalle.personal_cuenta" label="No. Cuenta" :readonly="!(roles.includes('administrador') || roles.includes('contabilidad') || roles.includes('tesoreria'))"></v-text-field>
                      <v-text-field v-model="detalle.personal_clabe" label="Referencia interbancaria" :readonly="!(roles.includes('administrador') || roles.includes('contabilidad') || roles.includes('tesoreria'))"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="questionEst" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea actualizar el estado del usuario?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionEst = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="saveEst()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionPer" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea actualizar los permisos del usuario?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionPer = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="savePer()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionCtaNom" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea actualizar los cuenta de nómina del usuario?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionCtaNom = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="saveCtaNom()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionCtaPer" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea actualizar los cuenta personal del usuario?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionCtaPer = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="saveCtaPer()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import services from "@/config/services";

export default {
  name: "usuarios",
  data: () => ({
    loading: false,
    success: false,
    error: false,
    msgSuccess: "",
    msgError: "",
    dialogDetUser: false,
    questionEst: false,
    questionPer: false,
    questionCtaNom: false,
    questionCtaPer: false,
    search: "",
    roles: [],
    pagination: {
      rowsPerPage: 7
    },
    headers: [
      { text: "Id", align: "center", sortable: false, value: "id" },
      { text: "Estado", align: "center", sortable: false, value: "estado" },
      { text: "Username", align: "center", sortable: false, value: "alias" },
      { text: "Nombre", align: "center", sortable: false, value: "nombre" },
      {
        text: "Fecha de Registros",
        align: "center",
        sortable: false,
        value: "fecha_registro"
      },
      {
        text: "Fecha de Actualización",
        align: "center",
        sortable: false,
        value: "fecha_actualizacion"
      }
    ],
    usuarios: [],
    detalle: {
      id: null,
      username: "",
      nombre: "",
      rfc: "",
      no_empleado: "",
      puesto: "",
      departamento: "",
      direccion: "",
      empresa: "",
      ubicacion: "",
      jefe_inmediato: "",
      fecha_registro: "",
      fecha_actualizacion: "",
      estado: null,
      permisos: [],
      nomina_banco: "",
      nomina_cuenta: "",
      nomina_tarjeta: "",
      nomina_clabe: "",
      personal_banco: "",
      personal_cuenta: "",
      personal_tarjeta: "",
      personal_clabe: ""
    }
  }),
  mounted() {
    this.refresh();
    this.ws("get", "check").then(res => {
      if (res.ok) {
        this.roles = res.data.roles;
      }
    });
  },
  methods: {
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    refresh() {
      this.loading = true;
      this.ws("get", "usuarios")
        .then(res => {
          if (res.ok) {
            this.usuarios = res.data.usuarios;
          } else {
            this.usuarios = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    syncUsers() {
      this.loading = true;
      this.ws("post", "sincronizarUsuarios")
        .then(res => {
          this.success = true;
          this.msgSuccess =
            "La sincronización ha comenzado, puede tardar unos minutos";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.detalle = {
        id: null,
        username: "",
        nombre: "",
        rfc: "",
        no_empleado: "",
        puesto: "",
        departamento: "",
        direccion: "",
        empresa: "",
        ubicacion: "",
        jefe_inmediato: "",
        fecha_registro: "",
        fecha_actualizacion: "",
        estado: null,
        permisos: [],
        nomina_banco: "",
        nomina_cuenta: "",
        nomina_tarjeta: "",
        nomina_clabe: "",
        personal_banco: "",
        personal_cuenta: "",
        personal_tarjeta: "",
        personal_clabe: ""
      };
      this.dialogDetUser = false;
    },
    prepareDetailForm(data) {
      this.detalle.id = data.general.id;
      this.detalle.username = data.general.username;
      this.detalle.nombre = data.general.nombre;
      this.detalle.rfc = data.general.rfc;
      this.detalle.no_empleado = data.general.no_empleado;
      this.detalle.puesto = data.general.puesto;
      this.detalle.departamento = data.general.departamento;
      this.detalle.direccion = data.general.direccion;
      this.detalle.empresa = data.general.empresa;
      this.detalle.ubicacion = data.general.ubicacion;
      this.detalle.jefe_inmediato = data.general.jefe_inmediato;
      this.detalle.fecha_registro = data.general.fecha_registro;
      this.detalle.fecha_actualizacion = data.general.fecha_actualizacion;
      this.detalle.estado = data.estado;
      this.detalle.permisos = data.permisos;
      this.detalle.nomina_banco = data.nomina.banco;
      this.detalle.nomina_cuenta = data.nomina.cuenta;
      this.detalle.nomina_tarjeta = data.nomina.tarjeta;
      this.detalle.nomina_clabe = data.nomina.clabe;
      this.detalle.personal_banco = data.personal.banco;
      this.detalle.personal_cuenta = data.personal.cuenta;
      this.detalle.personal_tarjeta = data.personal.tarjeta;
      this.detalle.personal_clabe = data.personal.clabe;
      this.dialogDetUser = true;
    },
    showDetailUser(id) {
      this.loading = true;
      this.ws("get", "detalleCompletoUsuario", { id })
        .then(res => {
          if (res.ok) {
            this.prepareDetailForm(res.data);
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveEst() {
      this.questionEst = false;
      if (
        this.detalle.estado === "activo" ||
        this.detalle.estado === "inactivo"
      ) {
        this.loading = true;
        let data = {
          id: this.detalle.id,
          estado: this.detalle.estado
        };
        this.ws("post", "actualizarEstadoUsuario", data)
          .then(res => {
            if (res.ok) {
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "Debe seleccionar un estado disponible";
      }
    },
    savePer() {
      this.questionPer = false;
      if (this.detalle.permisos.length) {
        this.loading = true;
        let data = {
          id: this.detalle.id,
          permisos: this.detalle.permisos
        };
        this.ws("post", "actualizarPermisosUsuario", data)
          .then(res => {
            if (res.ok) {
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "Debe asignar al menos un permiso disponible";
      }
    },
    saveCtaNom() {
      this.questionCtaNom = false;
      if (
        this.detalle.nomina_cuenta !== "" &&
        this.detalle.nomina_tarjeta !== "" &&
        this.detalle.nomina_clabe !== "" &&
        (this.detalle.nomina_cuenta.length == 11 ||
          this.detalle.nomina_cuenta == "N/A") &&
        (this.detalle.nomina_tarjeta.length == 16 ||
          this.detalle.nomina_tarjeta == "N/A") &&
        (this.detalle.nomina_clabe.length == 18 ||
          this.detalle.nomina_clabe == "N/A")
      ) {
        this.loading = true;
        let data = {
          id: this.detalle.id,
          cuenta: this.detalle.nomina_cuenta,
          tarjeta: this.detalle.nomina_tarjeta,
          clabe: this.detalle.nomina_clabe
        };
        this.ws("post", "actualizarCuentaNominaUsuario", data)
          .then(res => {
            if (res.ok) {
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "La información de la cuenta de nómina es incorrecta";
      }
    },
    saveCtaPer() {
      this.questionCtaPer = false;
      if (
        this.detalle.personal_cuenta !== "" &&
        this.detalle.personal_tarjeta !== "" &&
        this.detalle.personal_clabe !== "" &&
        (this.detalle.personal_cuenta.length == 11 ||
          this.detalle.personal_cuenta == "N/A") &&
        (this.detalle.personal_tarjeta.length == 16 ||
          this.detalle.personal_tarjeta == "N/A") &&
        (this.detalle.personal_clabe.length == 18 ||
          this.detalle.personal_clabe == "N/A")
      ) {
        this.loading = true;
        let data = {
          id: this.detalle.id,
          cuenta: this.detalle.personal_cuenta,
          tarjeta: this.detalle.personal_tarjeta,
          clabe: this.detalle.personal_clabe
        };
        this.ws("post", "actualizarCuentaPersonalUsuario", data)
          .then(res => {
            if (res.ok) {
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "La información de la cuenta personal es incorrecta";
      }
    }
  }
};
</script>
